<input style="width: 0px; height: 0px; position: absolute; top: -1000px" />
<!-- <div
    id="right-panel"
    class="flex flex-col gap-3 grow mt-1"
    style="max-width: calc(100% - 0px - 2rem)"
></div> -->
<!-- <p-fieldset legend="Είδη"></p-fieldset> -->

@let selectedInvoiceGroup =
    invoiceFormGroups()[
        selectedInvoiceTab() == 'services'
            ? 0
            : selectedInvoiceTab() == 'none'
              ? 0
              : 1
    ];

@if (selectedInvoiceGroup) {
    <!-- @let dclCustomerId = dclCard()?.CustomerId; -->
    @let invoiceTypeCode = selectedInvoiceGroup?.controls?.TypeCode?.value;
    @let isDeliveryNote = selectedInvoiceGroup?.controls?.IsDeliveryNote?.value;

    @let details = selectedInvoiceGroup?.controls?.Details?.controls ?? [];
    @let summary =
        (selectedInvoiceGroup?.controls?.Summaries?.controls ?? [])?.[0];

    @let invoiceMark =
        selectedInvoiceGroup?.get('Response')?.value?.InvoiceMark;

    <!-- <form [formGroup]="$any(selectedInvocieGroup)">
            <z-invoice-card-customer
                    #invoiceCardCustomer
                    [selectedCustomer]="selectedCustomer()"
                    (customerSelected)="onCustomerSelected($event)"
                ></z-invoice-card-customer>

            <z-invoice-card-header-info
                [selectedCustomer]="selectedCustomer()"
                (customerSelected)="onCustomerSelected($event)"
            ></z-invoice-card-header-info>
        </form> -->
    <!-- responsiveLayout="scroll"
            [scrollable]="false"
            [scrollHeight]="dialogHeight()" -->

    <!--  Το tab αυτό ισχυεί μονο για παραστατικά που εκδίδονται από Ψηφιακό Πελατολόγιο (DCLInvoiceTypeCode == undefined)-->
    @if (UseWithDCLInvoiceTypeCode() == true) {
        <p-tabs
            class="mb-2"
            [value]="selectedInvoiceTab()"
            (valueChange)="selectedInvoiceTabChange($event)"
        >
            <p-tablist>
                <p-tab
                    [value]="'products'"
                    class="flex items-center !gap-2 text-inherit"
                >
                    <!-- <i [class]="tab.icon"></i> -->
                    @if (invoiceTypeCode == '1.1' || invoiceTypeCode == '2.1') {
                        <span>Τιμολόγιο Πώλησης</span>
                    } @else {
                        <span>Απόδειξη Πώλησης</span>
                    }
                </p-tab>
                <p-tab
                    [value]="'services'"
                    class="flex items-center !gap-2 text-inherit"
                >
                    <!-- <i [class]="tab.icon"></i> -->

                    @if (invoiceTypeCode == '1.1' || invoiceTypeCode == '2.1') {
                        <span>Τιμολόγιο Παροχής Υπηρεσιών</span>
                    } @else {
                        <span>Απόδειξη Παροχής Υπηρεσιών</span>
                    }
                </p-tab>

                <!-- @for(tab of tabs; track tab.route){
            <p-tab [value]="tab.route" [routerLink]="tab.route" class="flex items-center !gap-2 text-inherit">
                <i [class]="tab.icon"></i>
                <span>{{ tab.label }}</span>
            </p-tab>
        } -->
            </p-tablist>
        </p-tabs>
    }

    <p-table
        [stripedRows]="false"
        [formGroup]="$any(selectedInvoiceGroup)"
        [value]="details"
        dataKey="_id"
        [rows]="10"
        [loading]="false"
        [totalRecords]="details.length"
        [rowHover]="true"
        [showGridlines]="true"
        [paginator]="false"
        [showCurrentPageReport]="false"
        currentPageReportTemplate="{first} εώς {last} από {totalRecords}"
        [rowsPerPageOptions]="[10, 25, 50]"
        [tableStyle]="{ 'min-width': '50rem' }"
    >
        <ng-template #caption>
            <div class="flex flex-row gap-2 justify-between">
                <div class="flex flex-col justify-start gap-2">
                    <!-- <span> Υπηρεσίες / Ανταλλακτικά </span> -->
                    <form [formGroup]="$any(selectedInvoiceGroup)">
                        <!-- v[disableCustomer]="dclCustomerId != undefined" -->
                        <z-invoice-card-header-info
                            [selectedCustomer]="selectedCustomer()"
                            [invoiceTypeCode]="invoiceTypeCode"
                            [isDeliveryNote]="isDeliveryNote"
                            (customerSelected)="onCustomerSelected($event)"
                        ></z-invoice-card-header-info>
                    </form>
                </div>
                <div class="flex flex-row gap-4">
                    <!-- <div class="mt-2 mr-4">
                        Αξίες προ Φόρων
                        <z-invoice-use-retail-prices-select
                            formControlName="UseRetailAfterTaxes"
                            (invoiceUseRetailPriceChange)="
                                onInvoiceUseRetailPriceChange()
                            "
                        >
                        </z-invoice-use-retail-prices-select>
                    </div> -->
                    @if ((summary?.controls?.TotalGrossValue?.value ?? 0) > 0) {
                        <div
                            class="total-gross-value flex flex-col justify-center"
                        >
                            <div
                                class="font-size-xx-small label-active-color self-end"
                            >
                                Καθαρή Αξία
                            </div>
                            <div class="font-size-x-large lt-color-gray-300">
                                {{
                                    summary?.controls?.TotalNetValue?.value
                                        | currency: 'EUR'
                                }}
                            </div>
                        </div>
                        <div
                            class="total-gross-value flex flex-col justify-center"
                        >
                            <div
                                class="font-size-xx-small label-active-color self-end"
                            >
                                Αξία Φ.Π.Α
                            </div>
                            <div class="font-size-x-large lt-color-gray-300">
                                {{
                                    summary?.controls?.TotalVATAmount?.value
                                        | currency: 'EUR'
                                }}
                            </div>
                        </div>
                        <div
                            class="total-gross-value flex flex-col justify-center ml-5"
                        >
                            <div
                                class="font-size-xx-small label-active-color self-end"
                            >
                                Πληρωτέο Ποσό
                            </div>
                            <div
                                class="font-size-xx-large p-button-link-active-color"
                            >
                                {{
                                    summary?.controls?.TotalGrossValue?.value
                                        | currency: 'EUR'
                                }}
                            </div>
                        </div>
                    }
                </div>
            </div>
        </ng-template>
        <ng-template #header>
            <tr class="customer-order-table-header">
                <th class="aa">A/A</th>
                <th class="product-code" class="w-14rem">Κωδικός</th>
                <th class="expand">Περιγραφή</th>
                <th style="text-align: center" class="w-3rem">Είδος</th>
                <th style="text-align: center" class="w-5rem">Ποσότητα</th>
                @if (columnAvailableQuantity) {
                    <th style="text-align: center">Διαθέσιμη Ποσότητα</th>
                }
                @if (packageQuantity) {
                    <th style="text-align: center">Ποσότητα Συσκευασίας</th>
                }
                <th style="text-align: center" class="w-9rem">Μ.Μ</th>
                <th style="text-align: right" class="w-6rem">Αξία Μονάδας</th>
                <!-- <th style="text-align: right">Σύνολο Αξίας</th> -->

                <!-- <th style="text-align: center" class="w-3rem">Έκπτωση (%)</th> -->
                <!-- <th style="text-align: right">Αξία Έκπτωσης</th> -->
                <th
                    style="text-align: right"
                    title="Σύνολο Αξίας Μετά Έκπτωσης"
                    class="w-9rem"
                >
                    Καθαρή Αξία
                </th>
                <th style="text-align: center" class="w-7rem">Φ.Π.Α</th>
                <!-- <th style="text-align: center">Φ.Π.Α Αξια</th> -->
                <th style="text-align: right" class="w-9rem">Τελική Αξία</th>
                <!-- <th>Αναμονή</th> <th>Εκτύπωση</th> -->
                <th style="width: 65px"></th>
            </tr>
        </ng-template>
        <ng-template
            #body
            let-detail
            let-editing="editing"
            let-rowIndex="rowIndex"
        >
            <ng-container formArrayName="Details">
                <tr
                    [formGroupName]="rowIndex"
                    (mouseenter)="onMouseEnter(rowIndex)"
                    (mouseleave)="onMouseLeave(rowIndex)"
                    [ngClass]="
                        detail.get('Deleted')?.value == true
                            ? 'deleted-record'
                            : ''
                    "
                >
                    <td class="aa">
                        {{ rowIndex + 1 }}
                    </td>
                    <td
                        [pEditableColumn]="detail.ProductpackageId"
                        pEditableColumnField="ProductpackageId"
                        style="text-align: center"
                    >
                        <z-product-select
                            [invoiceTypeCode]="invoiceTypeCode ?? ''"
                            [formControlName]="'Code'"
                            [index]="rowIndex"
                            [mode]="'lockedit'"
                            [inputMode]="'code'"
                            [kind]="detail.get('Kind')?.value"
                            [productPackage]="
                                detail.get('ProductPackage')?.value
                            "
                            [productPackageId]="detail.get('PPackageId')?.value"
                            (inputFocus)="onInputFocus($event)"
                            (inputBlur)="onInputBlur($event)"
                            (rowDataSelect)="onProductSelect($event)"
                        >
                        </z-product-select>

                        <!-- <p-cellEditor>
                                <ng-template #input>
                                    <z-product-select
                                        [invoiceTypeCode]="
                                            invoiceTypeCode ?? ''
                                        "
                                        [formControlName]="'Code'"
                                        [index]="rowIndex"
                                        [mode]="'lockedit'"
                                        [inputMode]="'code'"
                                        [productPackageId]="
                                            detail.get('PPackageId')?.value
                                        "
                                        (inputFocus)="onInputFocus($event)"
                                        (inputBlur)="onInputBlur($event)"
                                        (rowDataSelect)="
                                            onRowDataSelect($event)
                                        "
                                    >
                                    </z-product-select>
                                </ng-template>
                                <ng-template #output>
                                    <z-product-select
                                        [formControlName]="'Code'"
                                        [inputMode]="'code'"
                                        [productPackageId]="
                                            detail.get('PPackageId')?.value
                                        "
                                        [mode]="'view'"
                                    >
                                    </z-product-select>
                                </ng-template>
                            </p-cellEditor> -->
                    </td>
                    <td
                        [pEditableColumn]="detail.Descr"
                        pEditableColumnField="Descr"
                    >
                        <p-cellEditor>
                            <ng-template #input>
                                <z-float-label
                                    [formControlName]="'Descr'"
                                ></z-float-label>
                            </ng-template>
                            <ng-template #output>
                                @if (
                                    (detail.get('Descr')?.value ?? '').trim()
                                        .length == 0
                                ) {
                                    <input
                                        type="text"
                                        pInputText
                                        title="Καταχωρήστε την περιγραφή του Είδους ή της Υπηρεσίας που θέλετε."
                                        placeHolder="Περιγραφή"
                                        readonly="readonly"
                                        class="w-full"
                                    />
                                } @else {
                                    {{ detail.get('Descr')?.value }}
                                }
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <td
                        [pEditableColumn]="detail.Kind"
                        pEditableColumnField="Kind"
                        style="text-align: center"
                    >
                        @let isDetailRowKindDisabled =
                            detail.get('Kind')?.disabled ?? false;
                        @if (isDetailRowKindDisabled) {
                            {{
                                detail.get('Kind')?.value == 'S'
                                    ? 'Υπηρεσία'
                                    : 'Ανταλλακτικά'
                            }}
                        } @else {
                            <p-cellEditor>
                                <ng-template #input>
                                    <z-invoice-detail-kind-select
                                        [formControlName]="'Kind'"
                                        (onInvoiceDetailKindChange)="
                                            invoiceDetailKindChange(
                                                $event,
                                                rowIndex
                                            )
                                        "
                                    >
                                    </z-invoice-detail-kind-select>
                                </ng-template>
                                <ng-template #output>
                                    {{
                                        detail.get('Kind')?.value == 'S'
                                            ? 'Υπηρεσία'
                                            : 'Ανταλλακτικά'
                                    }}
                                </ng-template>
                            </p-cellEditor>
                        }
                    </td>
                    <td
                        [pEditableColumn]="detail.Quantity"
                        pEditableColumnField="Quantity"
                        style="text-align: center"
                    >
                        <p-cellEditor>
                            <ng-template #input>
                                <z-float-label-number
                                    [formControlName]="'Quantity'"
                                    [inputStyle]="{
                                        width: '70px',
                                        'text-align': 'center'
                                    }"
                                >
                                </z-float-label-number>
                            </ng-template>
                            <ng-template #output>
                                {{ detail.get('Quantity')?.value }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    @if (columnAvailableQuantity) {
                        <td>Διαθέσιμη Ποσότητα</td>
                    }
                    @if (packageQuantity) {
                        <td>Ποσότητα Συσκευασίας</td>
                    }

                    <td
                        [pEditableColumn]="detail.UnitTypeId"
                        pEditableColumnField="UnitTypeId"
                        style="text-align: center"
                    >
                        <p-cellEditor>
                            <ng-template #input>
                                <z-product-meter-unit-select
                                    [formControlName]="'UnitTypeId'"
                                    [options]="productsUnitsTypes()"
                                    (productUnitTypeChange)="
                                        productUnitChanged($event, rowIndex)
                                    "
                                ></z-product-meter-unit-select>
                            </ng-template>
                            <ng-template #output>
                                {{ detail.controls.MUnitDescr?.value }}
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td
                        [pEditableColumn]="detail.UnitValueUser"
                        pEditableColumnField="UnitValueUser"
                        style="text-align: right; width: 180px"
                    >
                        <p-cellEditor
                            style="
                                display: flex;
                                justify-self: end;
                                justify-content: end;
                            "
                        >
                            <ng-template #input>
                                <z-cash-register-cash
                                    [useRetailTaxesSource]="false"
                                    [inputStyle]="{
                                        width: '120px',
                                        'text-align': 'right'
                                    }"
                                    [formControlName]="'UnitValueUser'"
                                    (ngModelChange)="
                                        UnitValueUserChange(rowIndex, $event)
                                    "
                                >
                                </z-cash-register-cash>
                                <!-- <z-float-label-currency
                                            [inputStyle]="{
                                                width: '80px',
                                                'text-align': 'right'
                                            }"
                                            [formControlName]="'UnitValue'"
                                            [minFractionDigits]="2"
                                        ></z-float-label-currency> -->
                            </ng-template>
                            <ng-template #output>
                                {{
                                    detail.controls.UnitValueUser?.value
                                        | zCurrency
                                }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Έκπτωση -->
                    <!-- <td
                        [pEditableColumn]="detail.Disc"
                        pEditableColumnField="Disc"
                        style="text-align: center"
                    >
                        <p-cellEditor>
                            <ng-template #input>
                                <z-float-label-percent
                                    [inputStyle]="{
                                        width: '70px',
                                        'text-align': 'center'
                                    }"
                                    [min]="0"
                                    [max]="100"
                                    [formControlName]="'Disc'"
                                ></z-float-label-percent>
                            </ng-template>
                            <ng-template #output>
                                {{
                                    detail.controls?.Disc?.value
                                        | percent: '1.0-2'
                                }}
                            </ng-template>
                        </p-cellEditor>
                    </td> -->
                    <!-- Αξία Έκπτωσης -->
                    <!-- <td
                                style="text-align: right"
                                class="invoice-light-column"
                            >
                                {{
                                    detail.controls.DiscAmount?.value
                                        | currency: 'EUR'
                                }}
                            </td> -->
                    <!-- Καθαρή Αξία -->
                    <td style="text-align: right">
                        <!-- {{
                                    detail.controls.NetValue?.value | zCurrency
                                }} -->
                        {{ detail.controls.NetValueUser?.value | zCurrency }}
                    </td>
                    <!-- Φ.Π.Α -->
                    <td
                        [pEditableColumn]="detail.VATCategoryId"
                        pEditableColumnField="VATCategoryId"
                        style="text-align: center"
                    >
                        <p-cellEditor>
                            <ng-template #input>
                                <z-vat-categories-select
                                    [formControlName]="'VATCategoryId'"
                                    [options]="vatCategories()"
                                    (VATPercentChange)="
                                        VATPercentChange($event, rowIndex)
                                    "
                                ></z-vat-categories-select>
                            </ng-template>
                            <ng-template #output>
                                {{
                                    detail.controls.VATPercent?.value
                                        | percent: '1.0-2'
                                }}
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td style="text-align: right">
                        <!-- Τελική Αξία -->
                        {{
                            toFixed(
                                (detail.controls.NetValue?.value ?? 0) +
                                    (detail.controls.VATAmount?.value ?? 0)
                            ) | zCurrency
                        }}
                    </td>
                    <td>
                        @if (
                            details.length - 1 != rowIndex &&
                            selectedRowIndex == rowIndex &&
                            invoiceMark == undefined
                        ) {
                            <p-button
                                icon="pi pi-trash"
                                [rounded]="true"
                                [text]="true"
                                severity="danger"
                                title="Διαγραφή Εγγραφής Παραστατικού"
                                (onClick)="deleteInvoiceDetail(rowIndex)"
                            />

                            <!-- let-detail
                    let-editing="editing"
                    let-rowIndex="rowIndex" -->
                        }
                    </td>
                </tr>
            </ng-container>
        </ng-template>
    </p-table>
}

@if (renderInvoice == true) {
    <p-accordion value="1" [multiple]="true">
        <p-accordion-panel value="0">
            <p-accordion-header>
                <!-- <ng-template #toggleicon let-active="active">
                @if (active) {
                    <i class="pi pi-minus"></i>
                } @else {
                    <i class="pi pi-plus"></i>
                }
            </ng-template> -->
                <span class="flex items-center gap-2 w-full">
                    <!-- <p-avatar
                    image="https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png"
                    shape="circle"
                /> -->
                    <span class="font-bold whitespace-nowrap"
                        >Στοιχεία Παραστατικού</span
                    >
                    <!-- <p-badge value="3" class="ml-auto mr-2" /> -->
                </span>
            </p-accordion-header>
            <p-accordion-content>
                @if (selectedInvoiceGroup && renderInvoice) {
                    <form
                        [formGroup]="$any(selectedInvoiceGroup)"
                        class="mt-4 flex flex-col gap-3"
                    >
                        <!-- <ng-container [formGroupName]="'CounterPart'">
                        [<input [formControlName]="'Occupation'" />]
                        <z-float-label
                            [label]="'Επαγγελμα 222'"
                            [formControlName]="'Occupation'"
                        ></z-float-label>
                    </ng-container> -->
                        <div class="flex flex-col">
                            <z-invoice-card-header-info></z-invoice-card-header-info>
                        </div>
                        <div class="flex flex-row flex-wrap gap-4">
                            <z-invoice-card-customer
                                #invoiceCardCustomer
                                [selectedCustomer]="selectedCustomer()"
                                (customerSelected)="onCustomerSelected($event)"
                            ></z-invoice-card-customer>

                            <z-invoice-card-header-contacts></z-invoice-card-header-contacts>
                        </div>
                    </form>
                }
            </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel value="1">
            <p-accordion-header>
                <span class="flex items-center gap-2 w-full">
                    <!-- <p-avatar
                    image="https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png"
                    shape="circle"
                /> -->
                    <span class="font-bold whitespace-nowrap"
                        >Υπηρεσίες / Προϊόντα</span
                    >
                    <!-- <p-badge value="3" class="ml-auto mr-2" /> -->
                </span>
            </p-accordion-header>
            <p-accordion-content>
                @if (selectedInvoiceGroup) {
                    <p-table
                        [formGroup]="$any(selectedInvoiceGroup)"
                        [value]="
                            selectedInvoiceGroup?.controls?.Details?.controls ??
                            []
                        "
                        [totalRecords]="1"
                    >
                        <ng-template #header>
                            <tr class="customer-order-table-header">
                                <th class="aa">A/A</th>
                                <th class="product-code">Κωδικός</th>
                                <th style="text-align: center">
                                    Ζητούμενη Ποσότητα
                                </th>
                                <th class="expand">Περιγραφή Εϊδους</th>
                                @if (columnAvailableQuantity) {
                                    <th style="text-align: center">
                                        Διαθέσιμη Ποσότητα
                                    </th>
                                }
                                @if (packageQuantity) {
                                    <th style="text-align: center">
                                        Ποσότητα Συσκευασίας
                                    </th>
                                }
                                <th style="text-align: center">Μ.Μ</th>
                                <th style="text-align: right">Αξία Μονάδας</th>
                                <!-- <th style="text-align: right">Σύνολο Αξίας</th> -->

                                <th style="text-align: center">Έκπτωση (%)</th>
                                <th style="text-align: right">Αξία Έκπτωσης</th>
                                <th
                                    style="text-align: right"
                                    title="Σύνολο Αξίας Μετά Έκπτωσης"
                                >
                                    Καθαρή Αξία
                                </th>
                                <th style="text-align: center">Φ.Π.Α</th>
                                <!-- <th style="text-align: center">Φ.Π.Α Αξια</th> -->
                                <th style="text-align: right">Τελική Αξία</th>
                                <!-- <th>Αναμονή</th> <th>Εκτύπωση</th> -->
                            </tr>
                        </ng-template>
                        <ng-template
                            #body
                            let-detail
                            let-editing="editing"
                            let-rowIndex="rowIndex"
                        >
                            <ng-container formArrayName="Details">
                                <tr [formGroupName]="rowIndex">
                                    <td class="aa">{{ rowIndex + 1 }}</td>
                                    <td
                                        [pEditableColumn]="detail.Quantity"
                                        pEditableColumnField="ProductpackageId"
                                        style="text-align: center"
                                    >
                                        <p-cellEditor>
                                            <ng-template #input>
                                                <z-product-select
                                                    [index]="rowIndex"
                                                    [mode]="'edit'"
                                                    [inputMode]="'code'"
                                                    [productPackageId]="
                                                        detail.get('PPackageId')
                                                            ?.value
                                                    "
                                                    [formControlName]="'Code'"
                                                    (inputFocus)="
                                                        onInputFocus($event)
                                                    "
                                                    (inputBlur)="
                                                        onInputBlur($event)
                                                    "
                                                    (rowDataSelect)="
                                                        onProductSelect($event)
                                                    "
                                                >
                                                </z-product-select>
                                            </ng-template>
                                            <ng-template #output>
                                                <z-product-select
                                                    [inputMode]="'code'"
                                                    [productPackageId]="
                                                        detail.get('PPackageId')
                                                            ?.value
                                                    "
                                                    [mode]="'view'"
                                                    [formControlName]="'Code'"
                                                >
                                                </z-product-select>
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td
                                        [pEditableColumn]="detail.Quantity"
                                        pEditableColumnField="Quantity"
                                        style="text-align: center"
                                    >
                                        <p-cellEditor>
                                            <ng-template #input>
                                                <z-float-label-number
                                                    [formControlName]="
                                                        'Quantity'
                                                    "
                                                    [inputStyle]="{
                                                        width: '70px',
                                                        'text-align': 'center'
                                                    }"
                                                >
                                                </z-float-label-number>
                                            </ng-template>
                                            <ng-template #output>
                                                {{
                                                    detail.get('Quantity')
                                                        ?.value
                                                }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td
                                        [pEditableColumn]="detail.Descr"
                                        pEditableColumnField="Descr"
                                    >
                                        <p-cellEditor>
                                            <ng-template #input>
                                                <z-float-label
                                                    [formControlName]="'Descr'"
                                                ></z-float-label>
                                            </ng-template>
                                            <ng-template #output>
                                                {{ detail.get('Descr')?.value }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    @if (columnAvailableQuantity) {
                                        <td>Διαθέσιμη Ποσότητα</td>
                                    }
                                    @if (packageQuantity) {
                                        <td>Ποσότητα Συσκευασίας</td>
                                    }

                                    <td
                                        [pEditableColumn]="detail.UnitTypeId"
                                        pEditableColumnField="UnitTypeId"
                                    >
                                        <p-cellEditor>
                                            <ng-template #input>
                                                <z-product-meter-unit-select
                                                    [formControlName]="
                                                        'UnitTypeId'
                                                    "
                                                    [options]="
                                                        productsUnitsTypes()
                                                    "
                                                    (productUnitTypeChange)="
                                                        productUnitChanged(
                                                            $event,
                                                            rowIndex
                                                        )
                                                    "
                                                ></z-product-meter-unit-select>
                                            </ng-template>
                                            <ng-template #output>
                                                {{
                                                    detail.controls.MUnitDescr
                                                        ?.value
                                                }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>

                                    <td
                                        [pEditableColumn]="detail.UnitValue"
                                        pEditableColumnField="UnitValue"
                                        style="text-align: right"
                                    >
                                        <p-cellEditor>
                                            <ng-template #input>
                                                <z-float-label-currency
                                                    [inputStyle]="{
                                                        width: '80px',
                                                        'text-align': 'right'
                                                    }"
                                                    [formControlName]="
                                                        'UnitValue'
                                                    "
                                                    [minFractionDigits]="2"
                                                ></z-float-label-currency>
                                            </ng-template>
                                            <ng-template #output>
                                                {{
                                                    detail.controls.UnitValue
                                                        ?.value | zCurrency
                                                }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td
                                        [pEditableColumn]="detail.Disc"
                                        pEditableColumnField="Disc"
                                        style="text-align: center"
                                    >
                                        <p-cellEditor>
                                            <ng-template #input>
                                                <z-float-label-percent
                                                    [inputStyle]="{
                                                        width: '70px',
                                                        'text-align': 'center'
                                                    }"
                                                    [min]="0"
                                                    [max]="100"
                                                    [formControlName]="'Disc'"
                                                ></z-float-label-percent>
                                            </ng-template>
                                            <ng-template #output>
                                                {{
                                                    detail.controls?.Disc?.value
                                                        | percent: '1.0-2'
                                                }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <!-- Αξία Έκπτωσης -->
                                    <td style="text-align: right">
                                        {{
                                            detail.controls.DiscAmount?.value
                                                | zCurrency
                                        }}
                                    </td>
                                    <!-- Καθαρή Αξία -->
                                    <td style="text-align: right">
                                        {{
                                            detail.controls.NetValue?.value
                                                | zCurrency
                                        }}
                                    </td>
                                    <!-- Φ.Π.Α -->
                                    <td
                                        [pEditableColumn]="detail.UnitTypeId"
                                        pEditableColumnField="UnitTypeId"
                                        style="text-align: center"
                                    >
                                        <p-cellEditor>
                                            <ng-template #input>
                                                <z-vat-categories-select
                                                    [formControlName]="
                                                        'UnitTypeId'
                                                    "
                                                    [options]="vatCategories()"
                                                    (VATPercentChange)="
                                                        VATPercentChange(
                                                            $event,
                                                            rowIndex
                                                        )
                                                    "
                                                ></z-vat-categories-select>
                                            </ng-template>
                                            <ng-template #output>
                                                {{
                                                    detail.controls.VATPercent
                                                        ?.value
                                                        | percent: '1.0-2'
                                                }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>

                                    <td style="text-align: right">
                                        <!-- Τελική Αξία -->
                                        {{
                                            toFixed(
                                                (detail.controls.NetValue
                                                    ?.value ?? 0) +
                                                    (detail.controls.VATAmount
                                                        ?.value ?? 0)
                                            ) | zCurrency
                                        }}
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-template>
                    </p-table>
                }
            </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel value="2">
            <p-accordion-header>
                <span class="flex items-center gap-2 w-full">
                    <!-- <p-avatar
                    image="https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png"
                    shape="circle"
                /> -->
                    <span class="font-bold whitespace-nowrap">Σύνολα</span>
                    <!-- <p-badge value="3" class="ml-auto mr-2" /> -->
                </span>
            </p-accordion-header>
            <p-accordion-content>
                @if (selectedInvoiceGroup) {
                    @let summary =
                        selectedInvoiceGroup?.controls?.Summaries?.controls?.[0]?.getRawValue();

                    <div
                        [formGroup]="$any(selectedInvoiceGroup)"
                        class="flex flex-col gap-2"
                    >
                        <div [formArrayName]="'Notes'" class="flex flex-1">
                            <div [formGroupName]="0" class="flex flex-1">
                                <z-float-label-notes
                                    class="flex flex-1"
                                    [label]="'Παρατηρήσεις Παραστατικού'"
                                    [formControlName]="'Note'"
                                ></z-float-label-notes>
                            </div>
                        </div>
                        <div
                            [formArrayName]="'Summaries'"
                            class="flex flex-1 flex-col gap-2 mt-2"
                        >
                            <div
                                [formGroupName]="0"
                                class="flex flex-1 flex-row gap-2"
                            >
                                <!-- Υπόλοιπο Πελάτη -->
                                <!-- <div class="flex flex-row gap-2">                                
                                <p-table [value]="[{}]" [showGridlines]="true">
                                    <ng-template #caption>
                                        Υπόλοιπο Πελάτη
                                    </ng-template>
                                    <ng-template #header>
                                        <tr>
                                            <th style="min-width: 150px">
                                                Προηγούμενο
                                            </th>
                                            <th style="min-width: 150px">
                                                Νέο
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template #body let-vatCategory>
                                        <tr>
                                            <td>
                                                {{
                                                    summary?.PrevBalance
                                                        | currency: 'EUR'
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    summary?.NewBalance
                                                        | currency: 'EUR'
                                                }}
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div> -->
                                <div
                                    class="flex flex-1 flex-row gap-2 justify-content-end"
                                >
                                    <!-- Ανάλυση Φ.Π.Α -->
                                    <p-table
                                        [value]="[{}]"
                                        [showGridlines]="true"
                                        [style]="{ width: '300px' }"
                                        styleClass="vat-categories"
                                    >
                                        <ng-template #caption>
                                            Ανάλυση Φ.Π.Α
                                        </ng-template>
                                        <ng-template #header>
                                            <tr>
                                                @for (
                                                    item of vatCategories()
                                                        | appTaxFilter;
                                                    track item
                                                ) {
                                                    <th>{{ item.Title }}</th>
                                                }
                                            </tr>
                                        </ng-template>
                                        <ng-template #body let-vatCategory>
                                            <tr>
                                                @for (
                                                    item of vatCategories()
                                                        | appTaxFilter;
                                                    track item
                                                ) {
                                                    <td>
                                                        {{
                                                            taxesMap().get(
                                                                item.Value?.toString() ??
                                                                    ''
                                                            )?.Value ?? 0
                                                                | currency
                                                                    : 'EUR'
                                                        }}
                                                    </td>
                                                }
                                            </tr>
                                            <tr>
                                                @for (
                                                    item of vatCategories()
                                                        | appTaxFilter;
                                                    track item
                                                ) {
                                                    <td>
                                                        {{
                                                            taxesMap().get(
                                                                item.Value?.toString() ??
                                                                    ''
                                                            )?.Amount ?? 0
                                                                | currency
                                                                    : 'EUR'
                                                        }}
                                                    </td>
                                                }
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                    <!-- Σύνολα -->
                                    <p-table
                                        [value]="[{}]"
                                        [showGridlines]="true"
                                        class="flex grow"
                                    >
                                        <ng-template #caption>
                                            Σύνολα
                                        </ng-template>
                                        <ng-template #header>
                                            <tr>
                                                <th>Σύνολο Τεμαχίων</th>
                                                <th>Σύνολική Αξία</th>
                                                <th>Έκπτωση %</th>
                                                <th>Ποσό Έκπτωσης</th>
                                                <th>Συν. Καθαρής Αξίας</th>
                                                <th>Σύνολο Φ.Π.Α</th>
                                                <th>Πληρωτέο Ποσό</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template #body let-data>
                                            <tr>
                                                <td>
                                                    {{ summary?.Quantities }}
                                                </td>
                                                <td>
                                                    {{
                                                        summary?.TotalNetValueBeforeDiscount
                                                            | currency: 'EUR'
                                                    }}
                                                </td>
                                                <td>
                                                    <z-float-label-percent
                                                        [inputStyle]="{
                                                            width: '70px',
                                                            'text-align':
                                                                'center'
                                                        }"
                                                        [min]="0"
                                                        [max]="100"
                                                        (ngModelChange)="
                                                            discountPercentChanged(
                                                                $event
                                                            )
                                                        "
                                                        [formControlName]="
                                                            'DiscountPercent'
                                                        "
                                                    ></z-float-label-percent>
                                                </td>
                                                <td>
                                                    {{
                                                        summary?.DiscountAmount
                                                            | currency: 'EUR'
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        summary?.TotalNetValue
                                                            | currency: 'EUR'
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        summary?.TotalVATAmount
                                                            | currency: 'EUR'
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        summary?.TotalGrossValue
                                                            | currency: 'EUR'
                                                    }}
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </p-accordion-content>
        </p-accordion-panel>
    </p-accordion>
}
<!-- <pre>
    
     {{ invoiceFormGroup()?.controls?.Summaries?.value | json }}
</pre> -->
<!-- <pre>
    
     {{ invoiceFormGroup()?.value | json }}
</pre> -->
